module.exports = __webpack_public_path__ + "static/media/Eje-Herramienta-Inferior.86acb845.jpg";